// Rebuy Integration with Existing Card Product System
document.addEventListener('DOMContentLoaded', function() {
    
    // Wait for cart drawer to be available
    function waitForCartDrawer() {
        return new Promise((resolve) => {
            const checkDrawer = () => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    resolve(cartDrawer);
                } else {
                    setTimeout(checkDrawer, 100);
                }
            };
            checkDrawer();
        });
    }

    // Enhanced add to cart function for Rebuy products
    async function addRebuyProductToCart(variantId, quantity = 1) {
        try {
            const cartDrawer = await waitForCartDrawer();
            
            // Use the same structure as your existing card-product
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);
            
            // Add sections to render (same as your existing code)
            if (cartDrawer.getSectionsToRender) {
                formData.append(
                    'sections',
                    cartDrawer
                        .getSectionsToRender()
                        ?.map(section => section.section)
                );
            }

            // Handle cart page resubmission
            if (window.location.pathname === '/cart') {
                const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
                if (cartDrawerForm) {
                    cartDrawerForm.submit();
                    return;
                }
            }

            formData.append('sections_url', window.location.pathname);

            // Use your existing fetchConfig if available
            let config;
            if (typeof fetchConfig !== 'undefined') {
                config = fetchConfig('javascript');
            } else {
                config = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/javascript',
                    }
                };
            }
            
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            // Use your existing routes if available
            const addUrl = (typeof routes !== 'undefined' && routes.cart_add_url) 
                ? routes.cart_add_url 
                : '/cart/add';

            const addToCartResponse = await fetch(addUrl, config);
            const addToCartData = await addToCartResponse.json();

            if (!addToCartResponse.ok) {
                throw new Error(addToCartData.description || 'Failed to add product to cart');
            }

            // Use your existing cart drawer render method
            if (cartDrawer.renderContents) {
                cartDrawer.renderContents(addToCartData, false);
            } else {
                // Fallback: trigger cart update event
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    detail: addToCartData
                }));
            }
            
            // Ensure cart drawer is visible after adding product
            openCartDrawer(cartDrawer);

            // Show success notification
            // showRebuyNotification('Product added to cart!', 'success');
            
            return addToCartData;

        } catch (error) {
            console.error('Rebuy add to cart error:', error);
            // showRebuyNotification(error.message || 'Failed to add product to cart', 'error');
            throw error;
        }
    }

    // Function to get variant ID from product block
    function getVariantIdFromProduct(productBlock) {
        // Method 1: Check for variant select dropdown (for variation products)
        const variantSelect = productBlock.querySelector('.rebuy-select[title*="variant"], .rebuy-select[aria-label*="variant"]');
        if (variantSelect && variantSelect.value) {
            console.log('Found variant ID from select:', variantSelect.value);
            return variantSelect.value;
        }

        // Method 2: Check for selected radio button (alternative variation method)
        const selectedRadio = productBlock.querySelector('input[type="radio"]:checked');
        if (selectedRadio) {
            // Look for data attribute or value that might contain variant ID
            const variantId = selectedRadio.getAttribute('data-variant-id') || 
                             selectedRadio.getAttribute('value');
            if (variantId && variantId !== selectedRadio.value) {
                console.log('Found variant ID from radio:', variantId);
                return variantId;
            }
        }

        // Method 3: Check product link for variant parameter (for single products)
        const productLink = productBlock.querySelector('a[href*="variant="]');
        if (productLink) {
            const url = new URL(productLink.href, window.location.origin);
            const variantId = url.searchParams.get('variant');
            if (variantId) {
                console.log('Found variant ID from URL:', variantId);
                return variantId;
            }
        }

        // Method 4: Look for any element with variant ID data attribute
        const elementWithVariant = productBlock.querySelector('[data-variant-id]');
        if (elementWithVariant) {
            const variantId = elementWithVariant.getAttribute('data-variant-id');
            console.log('Found variant ID from data attribute:', variantId);
            return variantId;
        }

        // Method 5: Try to extract from the first select option if no specific variant is selected
        const firstSelect = productBlock.querySelector('.rebuy-select option[value]');
        if (firstSelect && firstSelect.value && firstSelect.value.match(/^\d+$/)) {
            console.log('Found variant ID from first option:', firstSelect.value);
            return firstSelect.value;
        }

        return null;
    }

    // Function to open cart drawer with multiple fallback methods
    function openCartDrawer(cartDrawer) {
        // Small delay to ensure cart contents are rendered first
        setTimeout(() => {
            // Method 1: Add is-visible class (your requirement)
            cartDrawer.classList.add('is-visible');
            
            // Method 2: Try built-in open method if available
            if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            }
            
            // Method 3: Try toggle method if available
            if (typeof cartDrawer.toggle === 'function') {
                cartDrawer.toggle();
            }
            
            // Method 4: Dispatch custom open event
            cartDrawer.dispatchEvent(new CustomEvent('cart-drawer:open'));
            
            // Method 5: Set focus for accessibility
            setTimeout(() => {
                const focusTarget = cartDrawer.querySelector('[tabindex="0"], button, input, select, textarea, [href]');
                if (focusTarget) {
                    focusTarget.focus();
                }
            }, 200);
            
            // Method 6: Add body class for overlay if needed
            document.body.classList.add('drawer-open', 'cart-drawer-open');
            
            // Method 7: Trigger any global cart open events
            document.dispatchEvent(new CustomEvent('cart:open', {
                detail: { source: 'rebuy' }
            }));
        }, 100);
    }

    function showRebuyNotification(message, type = 'success') {
        // Remove existing notification
        const existingNotification = document.querySelector('.rebuy-notification');
        if (existingNotification) {
            existingNotification.remove();
        }

        const notification = document.createElement('div');
        notification.className = `rebuy-notification rebuy-notification--${type}`;
        notification.innerHTML = `
            <div class="rebuy-notification__content">
                <span class="rebuy-notification__message">${message}</span>
                <button class="rebuy-notification__close" aria-label="Close notification">&times;</button>
            </div>
        `;

        document.body.appendChild(notification);

        // Add show class after a brief delay for animation
        setTimeout(() => {
            notification.classList.add('rebuy-notification--show');
        }, 10);

        // Auto hide after 4 seconds
        setTimeout(() => {
            hideNotification(notification);
        }, 4000);

        // Manual close functionality
        const closeBtn = notification.querySelector('.rebuy-notification__close');
        closeBtn.addEventListener('click', () => {
            hideNotification(notification);
        });

        function hideNotification(notificationEl) {
            notificationEl.classList.remove('rebuy-notification--show');
            setTimeout(() => {
                if (notificationEl.parentNode) {
                    notificationEl.parentNode.removeChild(notificationEl);
                }
            }, 300);
        }
    }

    // Main Rebuy integration function
    function initRebuyIntegration() {
        // Handle Rebuy add to cart buttons
        document.addEventListener('click', async function(e) {
            const rebuyButton = e.target.closest('.rebuy-button');
            
            if (!rebuyButton) return;
            
            // Check if this is an add to cart button
            const buttonText = rebuyButton.textContent.trim().toLowerCase();
            if (!buttonText.includes('add to cart') && !buttonText.includes('add')) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            // Prevent double clicks
            if (rebuyButton.classList.contains('rebuy-button--loading')) {
                return;
            }

            // Store original text
            const originalText = rebuyButton.innerHTML;
            console.log('🔥 Original button text:', originalText);
            
            // Add loading state
            rebuyButton.classList.add('rebuy-button--loading');
            rebuyButton.disabled = true;
            rebuyButton.innerHTML = '<span>Adding...</span>';
            console.log('🔥 Changed to Adding...');

            // Create a more reliable restore function
            const restoreButton = (delay = 0) => {
                console.log(`🔥 Scheduling restore in ${delay}ms`);
                setTimeout(() => {
                    console.log('🔥 Attempting to restore button...');
                    
                    try {
                        rebuyButton.classList.remove('rebuy-button--loading');
                        rebuyButton.disabled = false;
                        rebuyButton.innerHTML = 'Add to Cart';
                        console.log('🔥 Button restored successfully:', rebuyButton.innerHTML);
                    } catch (err) {
                        console.error('🔥 Error restoring button:', err);
                    }
                }, delay);
            };

            try {
                // Get product data from the Rebuy product block
                const productBlock = rebuyButton.closest('.rebuy-product-block');
                if (!productBlock) {
                    throw new Error('Product information not found');
                }

                // Get quantity
                const quantitySelect = productBlock.querySelector('.rebuy-select[aria-label*="quantity"], .product-quantity .rebuy-select');
                const quantity = quantitySelect ? parseInt(quantitySelect.value) : 1;
                console.log('🔥 Quantity:', quantity);

                // Get variant ID using the improved method
                const variantId = getVariantIdFromProduct(productBlock);
                console.log('🔥 Found variant ID:', variantId);

                if (!variantId) {
                    throw new Error('Cannot find variant ID. Please select a product variant.');
                }

                // Validate that variant ID is a number
                if (!variantId.match(/^\d+$/)) {
                    throw new Error('Invalid variant ID format: ' + variantId);
                }

                console.log('🔥 Adding product to cart with variant:', variantId, 'quantity:', quantity);
                
                // Add to cart using your existing system
                await addRebuyProductToCart(variantId, quantity);

                // Show success state
                console.log('🔥 Product added, showing success...');
                rebuyButton.innerHTML = '<span>Added ✓</span>';
                
                // Restore button after success
                restoreButton(1500);
                
                // Backup restoration methods
                setTimeout(() => {
                    if (rebuyButton.innerHTML.includes('Added ✓')) {
                        console.log('🔥 Backup restore triggered');
                        rebuyButton.classList.remove('rebuy-button--loading');
                        rebuyButton.disabled = false;
                        rebuyButton.innerHTML = originalText;
                    }
                }, 3000);

            } catch (error) {
                console.error('Rebuy integration error:', error);
                console.log('🔥 Showing error state...');
                
                // Show error state
                rebuyButton.innerHTML = '<span>Error ✗</span>';
                
                // Show user-friendly error message
                const errorMessage = error.message.includes('Cannot find variant') 
                    ? 'Please select product options first'
                    : 'Failed to add product to cart';
                
                // showRebuyNotification(errorMessage, 'error');
                
                // Restore after error
                restoreButton(2000);
                
                // Backup restoration for error
                setTimeout(() => {
                    if (rebuyButton.innerHTML.includes('Error ✗')) {
                        console.log('🔥 Backup error restore triggered');
                        rebuyButton.classList.remove('rebuy-button--loading');
                        rebuyButton.disabled = false;
                        rebuyButton.innerHTML = originalText;
                    }
                }, 4000);
            }
        });

        // Handle variant selection changes to update the product link
        document.addEventListener('change', function(e) {
            if (e.target.matches('.rebuy-select[title*="variant"], .rebuy-select[aria-label*="variant"]')) {
                const productBlock = e.target.closest('.rebuy-product-block');
                if (productBlock) {
                    const selectedVariantId = e.target.value;
                    console.log('🔥 Variant selection changed to:', selectedVariantId);
                    
                    // Update product links with the new variant ID
                    const productLinks = productBlock.querySelectorAll('a[href*="variant="]');
                    productLinks.forEach(link => {
                        const url = new URL(link.href, window.location.origin);
                        url.searchParams.set('variant', selectedVariantId);
                        link.href = url.toString();
                    });
                }
            }
        });
    }

    // Initialize when DOM is ready and Rebuy is loaded
    let rebuyInitialized = false;
    
    function checkAndInitRebuy() {
        if (rebuyInitialized) return;
        
        const rebuyProducts = document.querySelectorAll('.rebuy-product-block');
        if (rebuyProducts.length > 0) {
            rebuyInitialized = true;
            initRebuyIntegration();
            console.log('🔥 Rebuy integration initialized for', rebuyProducts.length, 'products');
        }
    }

    // Check immediately
    checkAndInitRebuy();

    // Also watch for dynamically loaded Rebuy content
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && 
                        (node.classList?.contains('rebuy-product-block') || 
                         node.querySelector?.('.rebuy-product-block'))) {
                        checkAndInitRebuy();
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Add CSS styles for notifications (commented out as per original)
    // const styles = `
    //     .rebuy-notification {
    //         position: fixed;
    //         top: 20px;
    //         right: 20px;
    //         z-index: 10000;
    //         transform: translateX(100%);
    //         transition: transform 0.3s ease;
    //         max-width: 350px;
    //     }
    //     /* ... rest of styles ... */
    // `;
});

// Export for potential external use
window.RebuyCartIntegration = {
    init: () => {
        // Re-initialize if needed
        document.dispatchEvent(new CustomEvent('DOMContentLoaded'));
    }
};